<template>
  <div class="irp-partner-cell ph-no-capture dd-privacy-mask">
    <BittsAvatar :org="partner" size="small" shape="square" class="shrink-0" />
    <div class="irp-partner-cell__text">
      <span class="irp-partner-cell__name">{{ partnerName }}</span>
      <span v-if="accountName" class="irp-partner-cell__account">
        {{ accountName }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BittsAvatar } from '@crossbeam/bitts';

import type { ICellRendererParams } from '@ag-grid-community/core';
import { computed } from 'vue';

import { MDM_PROPERTIES } from '@/constants/mdm';
import { usePartnersStore } from '@/stores';
import type { RecordOverviewPartnerType } from '@/types/individual_record';

const { params } = defineProps<{
  params: ICellRendererParams<RecordOverviewPartnerType>;
}>();

const partnersStore = usePartnersStore();

const partner = computed(() =>
  partnersStore.getPartnerOrgByUuid(
    params.data?.partner_organization_uuid ?? '',
  ),
);

const partnerName = computed(() => params.data?.partner_name ?? '');

const accountName = computed(() => {
  const nameField = params.data?.fields?.find(
    (field) => field.mdm_property === MDM_PROPERTIES.account.NAME,
  );
  return String(nameField?.value ?? '');
});
</script>

<style lang="pcss">
@reference "../../../css/theme.css";
.irp-partner-cell {
  @apply flex items-center gap-8 h-full w-full;
}

.irp-partner-cell__text {
  @apply flex flex-col justify-center min-w-0 leading-4;
}

.irp-partner-cell__name {
  @apply truncate text-sm font-semibold text-neutral-text-strong;
}

.irp-partner-cell__account {
  @apply truncate text-sm text-neutral-text-weak;
}
</style>
